import React, { useContext, useState, useEffect } from "react";
import { isEmpty, get, first } from "lodash";
import { Form, Button, Modal, Image, Row, Col } from "react-bootstrap";
import {
  faTrashAlt,
  faExclamationTriangle,
  faTimes,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  ManageMaintenanceLayout,
  LoaderWrapper,
  CsplTable as Table,
  FieldDropSide,
  SearchableList,
  CustomColumnMenu,
  MultiSelectDropdown,
  SliderPanel,
  DatePicker,
  FormControl,
  FieldInput,
} from "../../../components";
import {
  manageMaintenanceFormNames,
  formFields,
  getFlowBasedFormValues,
  getPathWithParam,
  MANAGE_COMPANY_ROUTES,
  FLOW_TYPES,
  usDateFormat,
  clearFieldValues,
  required,
} from "../../../utils";
import { useDeepEffect, useRouterParams, useRequest } from "../../../abstracts";
import {
  getCompaniesList,
  getScheduleExceptionReportMaster,
  getCompanyPlanPayrollFrequencies,
  getPayrollScheduleExceptionReport,
  updateSchedulePayDate,
  downloadPayrollScheduleExceptionReport,
} from "../../../services";
import {
  manageMaintenanceStore,
  setManagePageLevelData,
  setManageMaintenanceToastInfo,
} from "../../../contexts";
import { Formik, Field, ErrorMessage } from "formik";
import ExcelImage from "../../../styles/exportimg.PNG";
import company from "../../../mocks/company.json";
import frequency from "../../../mocks/payrollFrequency.json";
import scheduleExceptionReport from "../../../mocks/scheduleExceptionReport.json";
import { process } from "@progress/kendo-data-query";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { Link } from "react-router-dom";
import { ColumnMenu } from "./ColumnMenu";
import * as fileSaver from "file-saver";

class ProductNameHeader extends React.Component {
  render() {
    return (
      <a className="k-link" onClick={this.props.onClick}>
        <span title={this.props.title}>{this.props.title}</span>
        {this.props.children}
      </a>
    );
  }
}

const initialValues = {
  // companyName: "All",
  // companyId: null,
};
const all = { label: "All", value: null };
//const allOption = { label: "Select One", value: 0 };
const columns = [
  {
    value: 1,
    label: "Company",
    className: "column-frequency",
    columnName: "company",
    field: "company",
    width: 140,
    dataType: "alphaNumeric",
    field1: "companyName",
  },
  {
    value: 2,
    label: "Frequency",
    className: "column-frequency",
    columnName: "frequency",
    field: "frequency",
    width: 140,
    dataType: "alphaNumeric",
    field1: "payrollFrequency",
  },
  // {
  //   label: "Schedule start date",
  //   className: "column-scheduleStartDate",
  //   columnName: "scheduleStartDate",
  // },
  // {
  //   label: "Schedule end date",
  //   className: "column-scheduleEndDate",
  //   columnName: "scheduleEndDate",
  // },
  {
    value: 3,
    label: "Schedule start date",
    className: "column-scheduleStartDate",
    columnName: "scheduleStartDate",
    field: "scheduleStartDate",
    width: 175,
    dataType: "date",
    field1: "scheduleStartFrom",
    field2: "scheduleStartTo",
  },
  {
    value: 4,
    label: "Schedule end date",
    className: "column-scheduleEndDate",
    columnName: "scheduleEndDate",
    field: "scheduleEndDate",
    width: 175,
    dataType: "date",
    field1: "scheduleEndFrom",
    field2: "scheduleEndTo",
  },
  {
    value: 5,
    label: "Period start date",
    className: "column-periodStartDate",
    columnName: "periodStartDate",
    field: "periodStartDate",
    width: 165,
    dataType: "date",
    field1: "periodStartFrom",
    field2: "periodStartTo",
  },
  {
    value: 6,
    label: "Period end date",
    className: "column-periodEndDate",
    columnName: "periodEndDate",
    field: "periodEndDate",
    width: 165,
    dataType: "date",
    field1: "periodEndFrom",
    field2: "periodEndTo",
  },
  {
    value: 7,
    label: "PayDate",
    className: "column-paydate",
    columnName: "payDate",
    field: "payDate",
    width: 140,
    dataType: "date",
    field1: "payDateFrom",
    field2: "payDateTo",
  },
  {
    value: 8,
    label: "Action",
    className: "column-action",
    columnName: "action",
    field: "action",
    width: 100,
  },
];

const ScheduleExceptionReportContainer = (props) => {
  const { flow } = useRouterParams();
  const { state, dispatch } = useContext(manageMaintenanceStore);
  const [isLoading] = useState(false);
  const [final, setFinal] = useState([]);
  const [filteredValues, setFilteredValues] = useState([]);
  const { response, loading } = useRequest({
    method: getScheduleExceptionReportMaster,
    defaultResponse: filteredValues,
  });
  const formName = manageMaintenanceFormNames.SCHEDULE_EXCEPTION_REPORT;
  const fields = formFields[formName];
  const [fieldValues, setFieldValues] = useState([]);
  const [recordToDelete, setRecordToDelete] = useState({});
  const [exceptionTable, setPayrollScheduleExceptionTable] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [isScroll, setIsScroll] = useState(false);
  const [gridFilters, setGridFilters] = useState();
  const [companyList, setCompanyList] = useState("");
  const [pageCount, setPageCount] = useState(1);
  const [sorting, setSorting] = useState();
  const [toggle, setToggle] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(null);
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [dataItem, setDataItem] = useState({});
  const [totalRecord, setTotalRecord] = useState();
  const [selectedColumns, setSelectedColumns] = useState([
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
  ]);

  // const closeSlide = () =>{
  //   setIsSliderOpen(false);
  // }
  const showManageColumns = () => {
    let x = document.getElementsByClassName("manage-column-dropdown");
    let y = x[0].style.display;
    if (y === "none") {
      x[0].style.display = "block";
    } else {
      x[0].style.display = "none";
    }
  };
  const hideColumns = () => {
    setSelectedColumns(final.map((item) => item.value));
    let x = document.getElementsByClassName("manage-column-dropdown");
    let y = x[0].style.display;
    if (y === "block") {
      x[0].style.display = "none";
    } else {
      x[0].style.display = "block";
    }
  };
  document.addEventListener("mouseup", function (e) {
    let container = document.getElementsByClassName("manage-column-dropdown");
    let button = document.getElementsByClassName("column-header");
    if (container[0] && !container[0]?.contains(e.target)) {
      container[0].style.display = "none";
    }
  });
  const _export = React.useRef(null);

  const exportReportFile = () => {
    var column = columns.filter(
      (column) => !final.map((item) => item.value).includes(column.value)
    );
    var data = column.map((item) => item.value);
    downloadPayrollScheduleExceptionReport({
      ...filteredValues,
      selectedColumns: data,
    })
      .then((response) => {
        var blob = new Blob([response], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(blob, "PayrollScheduleExtensionExceptionReport.xlsx");
      })
      .catch((error) => {});
  };
  const sliderOpen = (dataitem) => {
    setDataItem(
      first(exceptionTable.filter((item) => item.payrollScheduleId == dataitem))
    );
    setFieldValues(fields.payDate, dataItem.payDate);
    setFieldValues(fields.payrollScheduleId, dataitem.payrollScheduleId);
    setIsSliderOpen(true);
  };

  // const onColumnsSubmit = (columnsState) => {
  //   setSelectedColumns(columnsState);
  // };
  const applyColumns = () => {
    if (selectedColumns.length >= 1) {
      setFinal(
        columns.filter((column) =>
          selectedColumns.map((x) => x).includes(column.value)
        )
      );
    }
    hideColumns();
  };
  const dateForm = (props) => {
    var value = usDateFormat(props.dataItem[props.field]);
    return renderValue(value);
  };
  const renderValue = (value) => {
    value = value?.dataItem ? value.dataItem[value.field] : value;
    return <td>{value ? <div>{value}</div> : <div>- </div>}</td>;
  };
  const [payrollFrequencies, setpayrollFrequencies] = useState([]);
  const { response: companies, loading: companyLoading } = useRequest({
    method: getCompaniesList,
    payload: 1, //TenantId, Hardcoding should be removed
    defaultResponse: [],
  });

  const { response: data } = useRequest({
    method: getCompanyPlanPayrollFrequencies,
    defaultResponse: [],
  });

  useDeepEffect(() => {
    setSelectedColumns(columns.map((item) => item.value));
    setFinal(columns);
  }, []);

  const onFormSubmit = (values) => {
    setGridFilters(null);
    if (values.companyId !== null) {
      setCompanyList(values.companyName);
      setPageCount(1);
      setIsScroll(true);
      var filters = {
        companyId: values.companyId,
        payrollFrequency: values.frequency,
        from: 1,
        count: 20,
        innerFilters: null,
        selectedColumns: selectedColumns,
      };
      setFilteredValues(filters);
      apiCall(filters);
    } else {
      setIsScroll(false);
      setPayrollScheduleExceptionTable([]);
      // setCompanyList("");
    }
    dispatch(
      setManagePageLevelData({
        formName: formName,
        fieldData: values,
      })
    );
  };
  const scrollHandler = (event) => {
    const e = event.nativeEvent;
    if (lastScrollTop === e.target.scrollTop) {
      return;
    }
    setLastScrollTop(e.target.scrollTop);
    if (
      e.target.scrollTop + 20 >=
      e.target.scrollHeight - e.target.clientHeight
    ) {
      if (isScroll) {
        var fromCount = pageCount * 20 + 1;
        var filters = {
          companyId: filteredValues.companyId,
          payrollFrequency: filteredValues.payrollFrequency,
          from: fromCount,
          count: 20,
          innerFilters: gridFilters,
        };
        setToggle(!toggle);
        setPageCount(pageCount + 1);
        setDataLoading(true);
        getPayrollScheduleExceptionReport(filters)
          .then((response) => {
            setDataLoading(false);
            if (response === []) {
              setIsScroll(false);
            }
            setPayrollScheduleExceptionTable([
              ...exceptionTable,
              ...response.payrollScheduleExceptionReport,
            ]);
          })
          .catch((error) => {
            setDataLoading(false);
          });
      }
    }
  };

  const closeSlide = (setErrors) => {
    setIsSliderOpen(false);
    setErrors({});
  };

  const savePaydate = (setFieldError, setErrors) => {
    const data = {
      payDate: dataItem.payDate,
      periodStartDate: dataItem.periodStartDate,
      periodEndDate: dataItem.periodEndDate,
      frequencyId: dataItem.frequencyId,
      payrollScheduleId: dataItem.payrollScheduleId,
    };
    updateSchedulePayDate(data).then((response) => {
      if (response.isSuccessfull == false) {
        for (var i = 0; i < response.errorCode.length; i++) {
          switch (response.controlName[i]) {
            case "PayDate":
              setFieldError(
                "PayDate",
                `${response.errorCode[i]}: ${response.errorMessage[i]}`
              );
              break;

            case "PeriodStart":
              setFieldError(
                "PeriodStart",
                `${response.errorCode[i]}: ${response.errorMessage[i]}`
              );
              break;
            case "PeriodEnd":
              setFieldError(
                "PeriodEnd",
                `${response.errorCode[i]}: ${response.errorMessage[i]}`
              );
              break;
            default:
              // setFieldError(_.controlName, _.messageDescCode);
              break;
          }
        }
      } else {
        apiCall(filteredValues);
        closeSlide(setErrors);
        dispatch(
          setManageMaintenanceToastInfo({
            showToast: true,
            toastMessage: "Data saved successfully",
          })
        );
      }
    });
  };

  const apiCall = (data) => {
    setDataLoading(true);
    getPayrollScheduleExceptionReport(data)
      .then((response) => {
        setDataLoading(false);
        setPayrollScheduleExceptionTable(
          response.payrollScheduleExceptionReport
        ); //rresponse.payrollScheduleExceptionReport
        setTotalRecord(response.count);
        if (response.count > 0) {
          setIsScroll(true);
        }
      })
      .catch((error) => {
        setDataLoading(false);
      });
  };
  useDeepEffect(() => {
    if (!isEmpty(companyList)) {
      setPageCount(1);
      setFilteredValues({
        ...filteredValues,
        from: 1,
        innerFilters: gridFilters,
      });
      apiCall({ ...filteredValues, innerFilters: gridFilters });
    }
  }, [gridFilters]);

  const actionCell = (props) => {
    const { dataItem } = props;
    return (
      <div className="marg-top-10 marg-left-20">
        <Link
          // id={dataItem.id}
          // to={getPathWithParam({
          //   path: MANAGE_COMPANY_ROUTES.PAYROLL_CALENDAR_MANAGE_PAYDATES,
          //   pathParam: [FLOW_TYPES.EDIT, companyId, dataItem.id, 0],
          // })}
          style={{ color: "royalblue" }}
          onClick={() => sliderOpen(dataItem.payrollScheduleId)}
        >
          Correct
        </Link>
      </div>
    );
  };
  return (
    <ManageMaintenanceLayout>
      <div className="w-100 maintenance-container">
        <div className="title-case">Schedule Exceptions Report</div>
        <Formik
          initialValues={{
            ...initialValues,
            ...getFlowBasedFormValues(get(state, formName, {}), flow),
          }}
          onSubmit={onFormSubmit}
          enableReinitialize
          validateOnChange={false}
          validateOnBlur={false}
        >
          {({
            handleChange,
            setFieldValue,
            setValues,
            handleSubmit,
            setFieldError,
            setErrors,
            values,
            errors,
            ...rest
          }) => {
            // const closeSlide = () =>{
            //   setIsSliderOpen(false);
            //   setErrors({});
            // }
            const onSave = () => {
              savePaydate(setFieldError, setErrors);
            };
            const onClose = () => {
              closeSlide(setErrors);
            };
            const onCompanyChange = (value) => {
              setValues({
                ...clearFieldValues({
                  //values: values,
                  fieldsToClear: [fields.frequency],
                }),
                [fields.companyId]:
                  value || value === 0 ? parseInt(companies[value].id) : null,
                [fields.companyName]:
                  value || value === 0 ? companies[value].name : "Select One",
              });
              if (value !== null) {
                let filteredpayroll = data.payrollFrequencies.filter((e) => {
                  return e.companyId == companies[value].id;
                });
                setFieldValue(fields.frequency, "");
                setpayrollFrequencies(filteredpayroll);
              }
              // getPlansDropDown(get(companies[value], "companyId", 0))
              //   .then((response) => {
              //     setPlanList(response);
              //   })
              //   .catch((error) => {
              //     //Handle Error
              //   });
            };
            return (
              <Form
                autoComplete="off"
                className="h-100"
                onSubmit={handleSubmit}
                validated={!isEmpty(rest.errors)}
              >
                <div className="d-flex justify-content-start">
                  <Field
                    size="smdd"
                    isRequired
                    label="Company name"
                    name={fields.companyName}
                    value={values[fields.companyName]}
                    placeholder="Select"
                    direction="bottom"
                    validate={(value) =>
                      ["", undefined, null, "Select One"].includes(value)
                        ? "Required"
                        : null
                    }
                    popupContent={
                      <SearchableList
                        label="Select Company"
                        options={[
                          // allOption,
                          ...companies.map((company, index) => ({
                            label: company.name,
                            value: index,
                          })),
                        ]}
                        name={fields.companyName}
                        onSelect={(value) => onCompanyChange(value, null)}
                        selectedValue={values[fields.companyName]}
                      />
                    }
                    component={FieldDropSide}
                  />
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <Field
                    label="Frequency Name"
                    isRequired
                    options={[all, ...payrollFrequencies]}
                    placeholder="All"
                    name={fields.frequency}
                    value={
                      values[fields.frequency]
                        ? values[fields.frequency]
                        : "All"
                    }
                    direction="right"
                    popupContent={
                      <SearchableList
                        label="Select Frequency"
                        options={[all, ...payrollFrequencies]}
                        onSelect={(value) =>
                          setFieldValue(fields.frequency, value)
                        }
                        selectedValue={values[fields.frequency]}
                        name={fields.frequency}
                        // isNotTypeAhead
                        isRadio
                      />
                    }
                    component={FieldDropSide}
                  />
                  <Button
                    style={{
                      height: "36px",
                      width: "100px",
                      marginLeft: "20px",
                      marginTop: "30px",
                    }}
                    type="submit"
                  >
                    Search
                  </Button>
                </div>
                <SliderPanel
                  isOpen={isSliderOpen}
                  size="35"
                  showCancel={false}
                  backdropClicked={onClose}
                  showCancelButton={true}
                  onClose={onClose}
                  showSave={true}
                  onSave={onSave}
                >
                  <div
                    className="title-case h5"
                    style={{ marginTop: "20px", marginLeft: "30px" }}
                  >
                    Manage Pay Date
                  </div>
                  <div style={{ marginTop: "50px", marginLeft: "30px" }}>
                    <div className="label">Company Name</div>
                    <div className="">{get(dataItem, "company")}</div>
                    <br />
                    <Field
                      size="md"
                      isRequired
                      label="Frequency Name"
                      name={"ScheduleEnd"}
                      value={get(dataItem, "frequency")}
                      placeholder="Frequency"
                      disabled={true}
                      component={FieldInput}
                    />
                    <Row>
                      <Col>
                        <Field
                          size="sm"
                          isRequired
                          label="Schedule Start Date"
                          name={"ScheduleStart"}
                          value={usDateFormat(dataItem.scheduleStartDate)}
                          isDatePicker
                          placeholder="PayDate"
                          disabled={true}
                          component={FieldDropSide}
                        />
                      </Col>
                      <div className="col-md-8">
                        <Field
                          size="sm"
                          isRequired
                          label="Schedule End Date"
                          name={"ScheduleEnd"}
                          value={usDateFormat(dataItem.scheduleEndDate)}
                          isDatePicker
                          placeholder="PayDate"
                          disabled={true}
                          component={FieldDropSide}
                        />
                        <ErrorMessage name="ScheduleEnd">
                          {(error) => <div>{error}</div>}
                        </ErrorMessage>
                      </div>
                    </Row>
                    <Row>
                      <Col>
                        <Field
                          size="sm"
                          isRequired
                          label="Period Start Date"
                          name={"PeriodStart"}
                          value={usDateFormat(dataItem.periodStartDate)}
                          isDatePicker
                          placeholder="PayDate"
                          direction="right"
                          validate={required}
                          onClear={() => {
                            setDataItem((dataItem) => {
                              return { ...dataItem, periodStartDate: "" };
                            });
                          }}
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                setDataItem((dataItem) => {
                                  return {
                                    ...dataItem,
                                    periodStartDate: value,
                                  };
                                })
                              }
                              value={usDateFormat(dataItem.periodStartDate)}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Field
                          size="sm"
                          isRequired
                          label="Period End Date"
                          name={"PeriodEnd"}
                          value={usDateFormat(dataItem.periodEndDate)}
                          isDatePicker
                          placeholder=""
                          direction="right"
                          validate={required}
                          onClear={() => {
                            setDataItem((dataItem) => {
                              return { ...dataItem, periodEndDate: "" };
                            });
                          }}
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                setDataItem((dataItem) => {
                                  return { ...dataItem, periodEndDate: value };
                                })
                              }
                              value={usDateFormat(dataItem.periodEndDate)}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </Col>
                    </Row>
                    <Field
                      size="sm"
                      isRequired={true}
                      label="PayDate"
                      name={"PayDate"}
                      value={usDateFormat(dataItem.payDate)}
                      isDatePicker
                      placeholder="PayDate"
                      direction="right"
                      validate={required}
                      onClear={() => {
                        setDataItem((dataItem) => {
                          return { ...dataItem, payDate: "" };
                        });
                      }}
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            setDataItem((dataItem) => {
                              return { ...dataItem, payDate: value };
                            })
                          }
                          value={usDateFormat(dataItem.payDate)}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </div>
                </SliderPanel>
              </Form>
            );
          }}
        </Formik>
        <div className="d-flex flex-col">
          <div
            style={{ fontSize: "14px", color: "#828282", paddingTop: "6px" }}
          >
            {companyList ? `Showing result for ${companyList} company` : null}
          </div>
          <div className="ft-12 grey-text font-weight-500">
            {totalRecord} Records found
          </div>
        </div>

        <div className="d-flex pad-top-10">
          <div
            style={{
              diplay: "flex",
              flexDirection: "column",
              marginLeft: "70%",
            }}
          >
            <div>
              <Button
                variant="secondary"
                className="column-header"
                style={{ border: "none", marginBottom: "20px" }}
                onClick={showManageColumns}
              >
                <span className="marg-right-6">
                  <i class="fal fa-columns"></i>
                </span>
                Column
              </Button>
            </div>
            <div className="manage-column-dropdown" style={{ display: "none" }}>
              <div className="manage-columns">
                <p className="manage-columns-button"> Manage columns</p>
                <p
                  className="apply-button"
                  onClick={() => {
                    applyColumns();
                  }}
                >
                  Apply
                </p>
              </div>
              <MultiSelectDropdown
                hideSelectedOptions="FALSE"
                width="269px"
                height="250px"
                maxHeight="459px"
                position="absolute"
                background="white"
                zIndex="2"
                options={columns}
                onSelect={(value) => {
                  setSelectedColumns(value);
                }}
                name={"Columns"}
                value={selectedColumns}
                // disabled={}
                //isTypeAhead={isEdit}
              />
            </div>
          </div>
          <div className="ft-12 grey-text font-weight-500 marg-right-5">
            <Button
              className="export-button"
              title="Export Excel"
              variant="secondary"
              style={{ border: "none" }}
              onClick={exportReportFile}
            >
              <Image src={ExcelImage} width="20px" />
              Export
            </Button>
          </div>
        </div>

        <div
          className="table-width-min grid-overflow"
          style={{ minWidth: "0px" }}
        >
          <LoaderWrapper isLoading={dataLoading}>
            <ExcelExport ref={exceptionTable}>
              <Grid
                data={exceptionTable}
                total={exceptionTable.length}
                style={{ height: "400px" }}
                onScroll={scrollHandler}
                resizable={true}
                fixedScroll
              >
                {final.map((column, idx) => (
                  <GridColumn
                    key={idx}
                    field={column.field}
                    width={column.width}
                    title={column.label}
                    filter={column.dataType}
                    cell={
                      (column.field === "action" && actionCell) ||
                      (column.dataType === "date" && dateForm)
                    }
                    headerCell={ProductNameHeader}
                    columnMenu={(props) =>
                      !isEmpty(exceptionTable) ? (
                        <ColumnMenu
                          {...props}
                          fields={fields}
                          sorting={sorting}
                          setSorting={setSorting}
                          gridFilters={gridFilters}
                          setGridFilters={setGridFilters}
                          field1={column.field1}
                          field2={column.field2 ? column.field2 : null}
                          columns={selectedColumns}
                        />
                      ) : null
                    }
                  />
                ))}
              </Grid>
            </ExcelExport>
          </LoaderWrapper>
        </div>
      </div>
    </ManageMaintenanceLayout>
  );
};

export default ScheduleExceptionReportContainer;
